export default __webpack_public_path__ + "e2ea0b04b8f4647dce2ad01698ba9ee6.svg";